import { Outlet, useNavigate } from "react-router-dom";
import { useNotificationWebsocket } from "@bsm/notification";
import { useRuntimeEnv, useTranslationRoute } from "@bsm/component";
import { useEffect } from "react";

const HareaContainer = () => {
  useNotificationWebsocket();
  const { runtimeEnv } = useRuntimeEnv();
  const isAuthenticated = runtimeEnv?.authenticated;
  const organisation = runtimeEnv?.organisation;
  const navigate = useNavigate();
  const t = useTranslationRoute();
  const routeIsAdmin = /(admin)/.test(location.pathname);

  useEffect(() => {
    if (
      isAuthenticated &&
      organisation !== null &&
      !routeIsAdmin &&
      location.pathname === `/${location.pathname.split("/")[1]}`
    ) {
      navigate(t("admin/project/calendar"));
    }
  }, [isAuthenticated, organisation, routeIsAdmin, navigate, t]);

  return <Outlet />;
};

export default HareaContainer;
